export default class PromotionListAction {
    static GET_PROMOTION_LIST_REQUEST = 'GET_PROMOTION_LIST_REQUEST';
    static GET_PROMOTION_LIST_SUCCESS = 'GET_PROMOTION_LIST_SUCCESS';
    static GET_PROMOTION_LIST_FAILED = 'GET_PROMOTION_LIST_FAILED';

    static promotionList_Request() {
        return {
            type: this.GET_PROMOTION_LIST_REQUEST
        }
    }

    static promotionList_Success (data) {
        return {
            type: this.GET_PROMOTION_LIST_SUCCESS,
            data
        }
    }

    static promotionList_Failed (error) {
        return {
            type: this.GET_PROMOTION_LIST_FAILED,
            error
        }
    }


    //DELETE PROMOTION

    static DELETE_PROMOTION_REQUEST = 'DELETE_PROMOTION_REQUEST';
    static DELETE_PROMOTION_SUCCESS = 'DELETE_PROMOTION_SUCCESS';
    static DELETE_PROMOTION_FAILED = 'DELETE_PROMOTION_FAILED';

    static promotion_delete_Request() {
        return {
            type: this.DELETE_PROMOTION_REQUEST
        }
    }

    static promotion_delete_Success (data) {
        return {
            type: this.DELETE_PROMOTION_SUCCESS,
            data
        }
    }

    static promotion_delete_Failed (error) {
        return {
            type: this.DELETE_PROMOTION_FAILED,
            error
        }
    }


    //BULK APPROVE

    static BULK_APPROVE_PROMOTION_REQUEST = 'BULK_APPROVE_PROMOTION_REQUEST';
    static BULK_APPROVE_PROMOTION_SUCCESS = 'BULK_APPROVE_PROMOTION_SUCCESS';
    static BULK_APPROVE_PROMOTION_FAILED = 'BULK_APPROVE_PROMOTION_FAILED';

    static promotion_bulk_approve_Request() {
        return {
            type: this.BULK_APPROVE_PROMOTION_REQUEST
        }
    }

    static promotion_bulk_approve_Success (data) {
        return {
            type: this.BULK_APPROVE_PROMOTION_SUCCESS,
            data
        }
    }

    static promotion_bulk_approve_Failed (error) {
        return {
            type: this.BULK_APPROVE_PROMOTION_FAILED,
            error
        }
    }


    //BULK DUPLICATE

    static BULK_DUPLICATE_PROMOTION_REQUEST = 'BULK_DUPLICATE_PROMOTION_REQUEST';
    static BULK_DUPLICATE_PROMOTION_SUCCESS = 'BULK_DUPLICATE_PROMOTION_SUCCESS';
    static BULK_DUPLICATE_PROMOTION_FAILED = 'BULK_DUPLICATE_PROMOTION_FAILED';

    static promotion_bulk_duplicate_Request() {
        return {
            type: this.BULK_DUPLICATE_PROMOTION_REQUEST
        }
    }

    static promotion_bulk_duplicate_Success (data) {
        return {
            type: this.BULK_DUPLICATE_PROMOTION_SUCCESS,
            data
        }
    }

    static promotion_bulk_duplicate_Failed (error) {
        return {
            type: this.BULK_DUPLICATE_PROMOTION_FAILED,
            error
        }
    }


    //BULK SEND BACK

    static BULK_SEND_BACK_PROMOTION_REQUEST = 'BULK_SEND_BACK_PROMOTION_REQUEST';
    static BULK_SEND_BACK_PROMOTION_SUCCESS = 'BULK_SEND_BACK_PROMOTION_SUCCESS';
    static BULK_SEND_BACK_PROMOTION_FAILED = 'BULK_SEND_BACK_PROMOTION_FAILED';

    static promotion_bulk_send_back_Request() {
        return {
            type: this.BULK_SEND_BACK_PROMOTION_REQUEST
        }
    }

    static promotion_bulk_send_back_Success(data) {
        return {
            type: this.BULK_SEND_BACK_PROMOTION_SUCCESS,
            data
        }
    }

    static promotion_bulk_send_back_Failed(error) {
        return {
            type: this.BULK_SEND_BACK_PROMOTION_FAILED,
            error
        }
    }

    static PROMOTION_EXTENSION_REQUEST = 'PROMOTION_EXTENSION_REQUEST';
    static PROMOTION_EXTENSION_SUCCESS = 'PROMOTION_EXTENSION_SUCCESS';
    static PROMOTION_EXTENSION_FAILED = 'PROMOTION_EXTENSION_FAILED';

    static promotion_extension_Request() {
        return {
            type: this.PROMOTION_EXTENSION_REQUEST
        }
    }

    static promotion_extension_Success(data) {
        return {
            type: this.PROMOTION_EXTENSION_SUCCESS,
            data
        }
    }

    static promotion_extension_Failed(error) {
        return {
            type: this.PROMOTION_EXTENSION_FAILED,
            error
        }
    }

    static BULK_RP_CALL_REQUEST = 'BULK_RP_CALL_REQUEST';
    static BULK_RP_CALL_SUCCESS = 'BULK_RP_CALL_SUCCESS';
    static BULK_RP_CALL_FAILED = 'BULK_RP_CALL_FAILED';

    static bulk_rp_call_Request() {
        return {
            type: this.BULK_RP_CALL_REQUEST
        }
    }

    static bulk_rp_call_Success(data) {
        return {
            type: this.BULK_RP_CALL_SUCCESS,
            data
        }
    }

    static bulk_rp_call_Failed(error) {
        return {
            type: this.BULK_RP_CALL_FAILED,
            error
        }
    }


    //BULK DUPLICATE NEXT YEAR

    static BULK_DUPLICATE_NEXT_YEAR_PROMOTION_REQUEST = 'BULK_DUPLICATE_NEXT_YEAR_PROMOTION_REQUEST';
    static BULK_DUPLICATE_NEXT_YEAR_PROMOTION_SUCCESS = 'BULK_DUPLICATE_NEXT_YEAR_PROMOTION_SUCCESS';
    static BULK_DUPLICATE_NEXT_YEAR_PROMOTION_FAILED = 'BULK_DUPLICATE_NEXT_YEAR_PROMOTION_FAILED';

    static promotion_bulk_duplicate_next_year_Request() {
        return {
            type: this.BULK_DUPLICATE_NEXT_YEAR_PROMOTION_REQUEST
        }
    }

    static promotion_bulk_duplicate_next_year_Success (data) {
        return {
            type: this.BULK_DUPLICATE_NEXT_YEAR_PROMOTION_SUCCESS,
            data
        }
    }

    static promotion_bulk_duplicate_next_year_Failed (error) {
        return {
            type: this.BULK_DUPLICATE_NEXT_YEAR_PROMOTION_FAILED,
            error
        }
    }

}